import type { MDXContent } from 'mdx/types';

import releaseNote0 from './notis/release-notes/2020-07-01.profile-apply.md';
import releaseNote1 from './notis/release-notes/2020-08-01.documentation-features.md';
import releaseNote2 from './notis/release-notes/2020-08-02.job-posting-features.md';
import releaseNote3 from './notis/release-notes/2020-09-01.mutation-conflicts.md';
import releaseNote4 from './notis/release-notes/2020-11-01.profile-apply-extensions.md';
import releaseNote5 from './notis/release-notes/2020-12-24.replay-webhook-subscriptions.md';
import releaseNote6 from './notis/release-notes/2021-04-13.mutation-split.md';
import releaseNote7 from './notis/release-notes/2021-04-20.position-profile-closed-event.md';
import releaseNote8 from './notis/release-notes/2021-04-27.mutation-input-field-limits.md';
import releaseNote9 from './notis/release-notes/2021-05-13.hirer-configuration-queries.md';
import releaseNote10 from './notis/release-notes/2021-05-19.update-webhook-conflicts.md';
import releaseNote11 from './notis/release-notes/2021-06-07.self-query.md';
import releaseNote12 from './notis/release-notes/2021-06-24.questionnaire-input-limits.md';
import releaseNote13 from './notis/release-notes/2021-08-13.hirer-relationship-changed-events.md';
import releaseNote14 from './notis/release-notes/2021-08-31.candidate-profile-position-profile.md';
import releaseNote15 from './notis/release-notes/2021-09-06.position-profile-created-by-self.md';
import releaseNote16 from './notis/release-notes/2021-10-31.content-discoverability.md';
import releaseNote17 from './notis/release-notes/2021-10-31.self-service-credential-management.md';
import releaseNote18 from './notis/release-notes/2021-11-04.downloading-hirer-list-csvs.md';
import releaseNote19 from './notis/release-notes/2021-11-24.advertisement-details-limit-lowered.md';
import releaseNote20 from './notis/release-notes/2021-12-14.replay-events-prior-subscription.md';
import releaseNote21 from './notis/release-notes/2021-12-22.new-graphql-explorer.md';
import releaseNote22 from './notis/release-notes/2022-02-22.question-html-limit.md';
import releaseNote23 from './notis/release-notes/2022-03-31.previewing-a-job-ad-feature.md';
import releaseNote24 from './notis/release-notes/2022-05-04.webhook-payload-hirer-id.md';
import releaseNote25 from './notis/release-notes/2022-10-06.unified-locations.md';
import releaseNote26 from './notis/release-notes/2022-10-18.email-parsing-retirement.md';
import releaseNote27 from './notis/release-notes/2022-11-17.webhook-playground.md';
import releaseNote28 from './notis/release-notes/2022-12-02.relaxed-string-length-limits.md';
import releaseNote29 from './notis/release-notes/2023-01-04.new-webhook-replays.md';
import releaseNote30 from './notis/release-notes/2023-05-05.cache-partner-token.md';
import releaseNote31 from './notis/release-notes/2023-10-06.job-ad-expiry-date-validation.md';
import releaseNote32 from './notis/release-notes/2023-11-23.commission-only.md';
import releaseNote33 from './notis/release-notes/2024-02-23.graphql-spec-compliance.md';
import releaseNote34 from './notis/release-notes/2024-06-19.inferlocation-countrycode.md';
import releaseNote35 from './notis/release-notes/2024-06-28.home-location.md';
import releaseNote36 from './notis/release-notes/2024-10-30.rate-limiting.md';
import releaseNote37 from './notis/release-notes/2024-11-07.removal-of-agencies.md';
import releaseNote38 from './notis/release-notes/2025-02-17.job-expiry-changes.md';
import releaseNote39 from './notis/release-notes/2025-03-11.webhook-security-enhancements.md';
import releaseNote40 from './notis/release-notes/2025-03-13.work-arrangements.md';
import releaseNote41 from './notis/release-notes/2025-08-15.hirer-scoped-subscriptions.md';
import releaseNote42 from './notis/release-notes/2026-01-14.asset-urls.md';
import releaseNote43 from './notis/release-notes/2026-08-26.http-header-casing.md';

export const releaseNotes: Record<string, MDXContent[]> = {
  '2020-07': [releaseNote0],
  '2020-08': [releaseNote2, releaseNote1],
  '2020-09': [releaseNote3],
  '2020-11': [releaseNote4],
  '2020-12': [releaseNote5],
  '2021-04': [releaseNote8, releaseNote7, releaseNote6],
  '2021-05': [releaseNote10, releaseNote9],
  '2021-06': [releaseNote12, releaseNote11],
  '2021-08': [releaseNote14, releaseNote13],
  '2021-09': [releaseNote15],
  '2021-10': [releaseNote17, releaseNote16],
  '2021-11': [releaseNote19, releaseNote18],
  '2021-12': [releaseNote21, releaseNote20],
  '2022-02': [releaseNote22],
  '2022-03': [releaseNote23],
  '2022-05': [releaseNote24],
  '2022-10': [releaseNote26, releaseNote25],
  '2022-11': [releaseNote27],
  '2022-12': [releaseNote28],
  '2023-01': [releaseNote29],
  '2023-05': [releaseNote30],
  '2023-10': [releaseNote31],
  '2023-11': [releaseNote32],
  '2024-02': [releaseNote33],
  '2024-06': [releaseNote35, releaseNote34],
  '2024-10': [releaseNote36],
  '2024-11': [releaseNote37],
  '2025-02': [releaseNote38],
  '2025-03': [releaseNote40, releaseNote39],
  '2025-08': [releaseNote41],
  '2026-01': [releaseNote42],
  '2026-08': [releaseNote43],
};
